const upcomingEvents = [
  {
    id: 1,
    title: "Family Fun Day",
    subtitle: "9am- 2pm, FREE ENTRY, Outdoor Event, Bumper Car Track, Video Games, Tables Games",
    startDate: "2026-09-19",
    endDate: "2026-09-19",
    date: "Sept 19",
    image: "/s3/family-fun-card.jpg",
    className: "activity-card--large",
    link: "https://maps.app.goo.gl/qQNeasvNMuFipJgz7"
  },
  {
    id: 2,
    title: "Live Wrestling",
    subtitle: "Doors @ 6:30PM. Bell Time @ 7:30PM",
    startDate: "2026-12-05",
    endDate: "2026-12-06",
    date: "Dec 5",
    image: "/s3/live-wrestling.jpg",
    className: "activity-card--large",
    link: "https://tickets.adssportscomplex.com/cd09702d-2c25-4b9d-be65-27cf7c4a0d25?tab=reserved"
  }
  // {
  //   id: 2,
  //   title: "VOLLEYBALL CAMPS & CLINICS",
  //   startDate: "2026-08-01",
  //   endDate: "2026-12-31",
  //   date: "AUG-DEC",
  //   image: "/s3/volleyball.jpg",
  //   className: "activity-card--large",
  //   link: "/volleyball"
  // },
  // {
  //   id: 3,
  //   title: "BASKETBALL CLINICS",
  //   startDate: "2026-08-11",
  //   endDate: "2026-08-27",
  //   date: "AUG 11-27",
  //   image: "/s3/basketball.jpg",
  //   className: "activity-card--large",
  //   link: "/Basketball"
  // },

  // {
  //   id: 2,
  //   title: "King Kyle Lee",
  //   subtitle: "Invitation Only",
  //   startDate: "2026-07-26",
  //   endDate: "2026-07-26",
  //   date: "JUL 26",
  //   image: "/s3/king_kyle_lee.jpg",
  //   className: "activity-card--large"
  // },
  // {
  //   id: 3,
  //   title: "Live Jazz",
  //   startDate: "2026-08-09",
  //   endDate: "2026-08-09",
  //   date: "AUG 9",
  //   image: "/s3/live-jazz.jpg",
  //   className: "activity-card--large"
  // },
  // {
  //   id: 4,
  //   title: "Comedy Spot",
  //   startDate: "2026-08-14",
  //   endDate: "2026-08-14",
  //   date: "AUG 14",
  //   image: "/s3/comedy-spot.jpg",
  //   className: "activity-card--large"
  // },
  // {
  //   id: 5,
  //   title: "Farmers Market",
  //   subtitle: "9AM-1PM",
  //   startDate: "2026-08-22",
  //   endDate: "2026-08-22",
  //   date: "AUG 22",
  //   image: "/s3/farmers-market.jpg",
  //   className: "activity-card--large"
  // },
  
];

export default upcomingEvents;